import React from 'react';

import {
  useLocation,
}                 from "react-router-dom";

import queryString from 'query-string';

import { Logger } from 'aws-amplify';

import { 
  ExecutionCard,
  useExecution,
}                                   from '../components/execution';

const logger = new Logger('Execution');

const Execution = ({ match }) => {

  const { search } = useLocation();
  const { inputs: withResult } = queryString.parse(search);
  
  const {
    params: { id },
  } = match;
  
  // TODO: add the client from useContext here to make this work for non admins
  const { execution, loading, error } = useExecution(id, {subscribed: true});

  if(error) {
    logger.error(error);
    return(null);
  }
  
  if(!execution || loading) return(null); 
 
  return (
    <ExecutionCard execution={execution} showInputs={withResult}/>
  );
};

export default Execution;